const o = /* @__PURE__ */ Symbol("formContextKey"), t = /* @__PURE__ */ Symbol("formItemContextKey");
export {
  o as formContextKey,
  t as formItemContextKey
};
